import React, { useState, useEffect } from 'react'
import {
  PhoneInput as PhoneInpuBuffet,
  PhoneNumber
} from '@toasttab/buffet-pui-phone-input'
import { useLoyaltyContext } from '../context/LoyaltyContext'
import { checkCountryIsoCode } from '@toasttab/buffet-pui-country-utilities'
import { isValidPhoneNumber } from 'libphonenumber-js'
import { t } from '@local/translations'

type Params = {
  phoneInput: string
  setPhoneInput: (phone: string) => void
  disabled?: boolean
  required?: boolean
  showLabel?: boolean
}

export const PhoneInput = ({
  phoneInput,
  setPhoneInput,
  disabled = false,
  required = false,
  showLabel = true
}: Params) => {
  const { config } = useLoyaltyContext()
  const [hasBlurred, setHasBlurred] = useState(false)
  const [phoneInputErrors, setPhoneInputErrors] = useState({})

  // Reset validation state when input is cleared externally (e.g., tab switch)
  useEffect(() => {
    if (!phoneInput.trim()) {
      setHasBlurred(false)
      setPhoneInputErrors({})
    }
  }, [phoneInput])

  const validatePhone = (phone: string) => {
    if (required && !phone.trim()) {
      return t('form.errors.phone.required')
    }
    if (
      phone.trim() &&
      !isValidPhoneNumber(phone, config?.restaurantCountryCode || 'US')
    ) {
      return t('form.errors.phone.invalid')
    }
    return '' // no error
  }

  const onChangePhone = (phoneNumber: PhoneNumber) => {
    const value = phoneNumber?.nationalNumber ?? ''
    setPhoneInput(value)
    // For required fields, validate on change if field has been blurred
    if (required && hasBlurred) {
      const error = validatePhone(value)
      setPhoneInputErrors({
        nationalNumber: error
      })
    } else {
      // For required fields that haven't been blurred yet, or non-required fields
      // Clear any existing errors
      setPhoneInputErrors({})
    }
  }

  const onBlur = () => {
    setHasBlurred(true)
    const error = validatePhone(phoneInput)
    setPhoneInputErrors({
      nationalNumber: error
    })
  }

  return (
    <div className='w-full'>
      <PhoneInpuBuffet
        label={showLabel ? t('form.labels.phone') : ''}
        name='phone'
        value={{
          countryIsoCode: checkCountryIsoCode(config?.restaurantCountryCode),
          nationalNumber: phoneInput
        }}
        onChange={onChangePhone}
        onBlur={onBlur}
        disableCountry={true}
        disabled={disabled}
        required={required}
        errors={phoneInputErrors}
        ariaLabelNumberInput={t('form.labels.phone')}
      />
    </div>
  )
}
